/* LURE theme scripts — vanilla, no dependencies */
(function () {
  'use strict';

  /* ---------------------------------------------------------
     Header: mobile nav + search toggles
  --------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-toggle-target]');
    if (!toggle) return;
    var panel = document.getElementById(toggle.getAttribute('data-toggle-target'));
    if (!panel) return;
    var isOpen = panel.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (isOpen) {
      var focusable = panel.querySelector('input, a, button');
      if (focusable) focusable.focus();
    }
  });

  /* ---------------------------------------------------------
     Product gallery
  --------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery.querySelector('[data-gallery-main]');
    if (!main) return;
    main.src = thumb.getAttribute('data-media-src');
    main.alt = thumb.getAttribute('data-media-alt') || '';
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (el) {
      el.setAttribute('aria-current', el === thumb ? 'true' : 'false');
    });
  });

  function showMedia(gallery, mediaId) {
    if (!gallery || !mediaId) return;
    var thumb = gallery.querySelector('[data-media-id="' + mediaId + '"]');
    if (thumb) thumb.click();
  }

  /* ---------------------------------------------------------
     Quantity steppers
  --------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-quantity-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var min = parseInt(input.min || '1', 10);
    var next = (parseInt(input.value, 10) || min) + parseInt(step.getAttribute('data-quantity-step'), 10);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------
     Variant picker — always resolves to an in-stock variant
  --------------------------------------------------------- */
  function escapeValue(value) {
    return window.CSS && CSS.escape ? CSS.escape(value) : value.replace(/["\\]/g, '\\$&');
  }

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  function initVariants(root) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    var moneyFormat = dataEl.getAttribute('data-money-format');
    var idInput = root.querySelector('[data-variant-id]');
    var addButton = root.querySelector('[data-add-button]');
    var priceHolder = root.querySelector('[data-price]');
    var compareHolder = root.querySelector('[data-compare-price]');
    var gallery = document.querySelector('[data-gallery]');
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));

    function selectedOptions() {
      var values = [];
      inputs.forEach(function (input) {
        if (input.checked) values[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
      });
      return values;
    }

    function matchExact(options) {
      return variants.filter(function (variant) {
        return variant.options.every(function (value, index) {
          return options[index] === undefined || value === options[index];
        });
      })[0];
    }

    /* Prefer an available variant that keeps the option the shopper just changed. */
    function resolve(options, changedIndex) {
      var available = variants.filter(function (variant) {
        return variant.available;
      });
      var candidates = available.length ? available : variants;

      var best = null;
      var bestScore = -1;
      candidates.forEach(function (variant) {
        if (changedIndex !== null && variant.options[changedIndex] !== options[changedIndex]) return;
        var score = 0;
        variant.options.forEach(function (value, index) {
          if (value === options[index]) score += index === changedIndex ? 100 : 1;
        });
        if (score > bestScore) {
          bestScore = score;
          best = variant;
        }
      });

      return best || candidates[0];
    }

    function markUnavailable(current) {
      inputs.forEach(function (input) {
        var index = parseInt(input.getAttribute('data-option-index'), 10);
        var probe = current.options.slice();
        probe[index] = input.value;
        var match = variants.filter(function (variant) {
          return variant.options.every(function (value, i) {
            return value === probe[i];
          });
        })[0];
        var label = root.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !match || !match.available);
      });
    }

    function apply(variant) {
      if (!variant) return;

      variant.options.forEach(function (value, index) {
        var input = root.querySelector('[data-option-index="' + index + '"][value="' + escapeValue(value) + '"]');
        if (input) input.checked = true;
        var display = root.querySelector('[data-option-selected="' + index + '"]');
        if (display) display.textContent = value;
      });

      if (idInput) idInput.value = variant.id;
      if (priceHolder) priceHolder.textContent = formatMoney(variant.price, moneyFormat);
      if (compareHolder) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareHolder.hidden = !onSale;
        if (onSale) compareHolder.textContent = formatMoney(variant.compare_at_price, moneyFormat);
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = addButton.getAttribute(variant.available ? 'data-label-available' : 'data-label-sold-out');
      }
      if (variant.featured_media_id) showMedia(gallery, String(variant.featured_media_id));

      markUnavailable(variant);

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var changedIndex = parseInt(input.getAttribute('data-option-index'), 10);
        var options = selectedOptions();
        var exact = matchExact(options);
        apply(exact && exact.available ? exact : resolve(options, changedIndex));
      });
    });

    /* On load: snap to the first in-stock variant so nobody lands on a sold-out default. */
    var initial = matchExact(selectedOptions());
    apply(initial && initial.available ? initial : resolve(selectedOptions(), null));
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-product-root]').forEach(initVariants);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Re-initialise inside the theme editor. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();